import { render, staticRenderFns } from "./ui-tabs-svg-dialog.vue?vue&type=template&id=780ed5f2&scoped=true"
import script from "./ui-tabs-svg-dialog.vue?vue&type=script&lang=js"
export * from "./ui-tabs-svg-dialog.vue?vue&type=script&lang=js"
import style0 from "./ui-tabs-svg-dialog.vue?vue&type=style&index=0&id=780ed5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ed5f2",
  null
  
)

export default component.exports